import cn from "classnames";
import { RouteView, Map as SharedMap } from "components/map/shared";
import { metersToReadableDistance, secondsToReadableTime } from "helpers/map";
import compact from "lodash/compact";
import React, { Component } from "react";

export default class BidRoute extends Component {
    state = {
        zoom: 6,
        center: [55.7473, 52.4568],
        modalOpened: false,
    };

    componentDidMount() {
        if (this.props.editRoute && !this.state.modalOpened) {
            this.props.setValue({ name: "editRoute", value: false });
            this.editRoute(this.props.confirmRoute);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.editRoute && !this.state.modalOpened) {
            nextProps.setValue({ name: "editRoute", value: false });
            this.editRoute(nextProps.confirmRoute);
        }
    }

    handleViewportChange = (nextState) => {
        this.setState(nextState);
    };

    openModal = (params) => {
        const {
            setValue,
            onCloseAction,
            pointsNotComparedToSegments,
            tileUrls,
            onSubmitAndStart,
            history,
            fromShowPage,
            carOption,
            availableFeatureModules,
            refueling,
            kind,
            itemChangePoints,
            emergencyAreaPoints,
            routeControlPoints,
            unstableZones,
            refuelingServiceType,
            organization,
            refuelingSettings,
            roles,
            isFirstBid,
        } = this.props;
        const { bidId, bidPoints, route, defaultRouteOptions, confirmRoute } = params;

        const config = {
            name: "routeSegments",
            windowMod: "route",
            mod: "create-route",
            title: "Редактирование маршрута",
            tileUrls,
            pointsNotComparedToSegments,
            route,
            roles,
            defaultRouteOptions,
            bidPoints,
            bidId,
            onCloseAction,
            onSubmitAndStart,
            confirmRoute,
            history,
            fromShowPage,
            carOption,
            refueling,
            availableFeatureModules,
            itemChangePoints,
            emergencyAreaPoints,
            routeControlPoints,
            unstableZones,
            kind,
            refuelingServiceType,
            organization,
            refuelingSettings,
            isFirstBid,
            action: () => setValue({ name: "route", value: true }),
        };
        return this.props.modal(config);
    };

    createRoute = () => {
        this.confirmModal("new");
    };

    confirmModal = () => {
        const { submitBid, getBidInfo, confirmRoute, defaultRouteOptions } = this.props;
        const config = {
            name: "confirm",
            title: "Редактирование маршрута",
            text: "Перед редактированием маршрута необходимо сохранить заявку",
            buttons: { confirm: "Сохранить" },
            action: () => undefined,
            onSuccessAction: () =>
                submitBid()
                    .then(({ id }) => getBidInfo(id))
                    .then(([bid, route]) => {
                        const { id, bidPoints } = bid;
                        this.openModal({ bidId: id, bidPoints, route, confirmRoute, defaultRouteOptions });
                    }),
        };
        return this.props.modal(config);
    };

    editRoute = (confirmRoute) => {
        this.setState({ modalOpened: true });
        const { pointsNotComparedToSegments, bidId, bidPoints, route, defaultRouteOptions } = this.props;
        if (pointsNotComparedToSegments && route) {
            this.confirmModal();
        } else {
            return this.openModal({ bidId, bidPoints, route, defaultRouteOptions, confirmRoute });
        }
    };

    changeMapPosition = (bounds) => {
        const notNullPoints = [...compact(bounds)];
        setTimeout(() => {
            if (notNullPoints.length && this.map) {
                this.map.fitBounds(notNullPoints, { maxZoom: 10, padding: [50, 50] });
            }
        }, 200);
    };

    renderMap = () => {
        const { tileUrls, bidPoints, bidId } = this.props;
        if (!tileUrls) {
            return null;
        }
        return (
            <SharedMap
                ref={(map) => (this.map = map)}
                mapRef={this.map}
                viewport={this.state}
                className="f-route__map"
                onViewportChanged={this.handleViewportChange}
                tileUrls={tileUrls}
                zoomControl={false}
                maxZoom={18}
                dragging={false}
                keyboard={false}
                scrollWheelZoom={false}
                doubleClickZoom={false}
            >
                <RouteView
                    changeMapPosition={this.changeMapPosition}
                    route={this.props.route}
                    routePoints={[]}
                    bidId={bidId}
                    bidPoints={bidPoints}
                    isPreview
                />
            </SharedMap>
        );
    };

    renderRoutePreview = () => {
        const { pointsNotComparedToSegments, route } = this.props;
        const { durationWithoutEmptyMileage, distanceWithoutEmptyMileage, duration, distance } = route;
        const durationStr = secondsToReadableTime(durationWithoutEmptyMileage || duration);
        const distanceStr = metersToReadableDistance(distanceWithoutEmptyMileage || distance);
        const showWarning = pointsNotComparedToSegments;
        const cname = cn("book-form__route f-route", { "f-route__error": showWarning });
        return (
            <div className={cname}>
                {showWarning && (
                    <div className="book-form__info-block">
                        Маршрут не актуален, необходимо обновить.&nbsp;
                        <a onClick={() => this.editRoute()} className="link">
                            Изменить маршрут
                        </a>
                    </div>
                )}
                <div className="f-route__head">
                    <div className="f-route__info">
                        {durationStr} | {distanceStr}
                    </div>
                    <div className="f-route__actions">
                        <div className="btn btn-brand btn-sm f-route__action--edit" onClick={() => this.editRoute()}>
                            Изменить
                        </div>
                    </div>
                </div>
                <div className="f-route__body">{this.renderMap()}</div>
            </div>
        );
    };

    renderRouteSectionBody = () => {
        const { route } = this.props;
        if (route) {
            return this.renderRoutePreview();
        }
    };

    render() {
        const { pointsNotComparedToSegments } = this.props;
        const showWarning = pointsNotComparedToSegments;
        const ctitle = cn("book-form__section-title", {
            "book-form__section-title--error": showWarning,
        });

        return (
            <div>
                <div className="form-group">
                    <strong className={ctitle}>Маршрут</strong>
                </div>
                {this.renderRouteSectionBody()}
            </div>
        );
    }
}
